import { FunctionComponent, useContext } from 'react'
import styled, { ThemeContext } from 'styled-components'
import SvgIcon from '@components/SvgIcon'
import { SvgIconName } from '@components/SvgIcon/types'

const LoginSvgIcon = styled(SvgIcon)`
  line-height: 1;
  text-align: center;
`

interface LoginIconProps {
  iconName: SvgIconName
}

const LoginLogoutIcon: FunctionComponent<LoginIconProps> = ({ iconName }) => {
  const theme = useContext(ThemeContext)
  const {
    colors: {
      grey: { grey_80 },
    },
    measures: {
      navigationBar: { iconSize },
    },
  } = theme

  return <LoginSvgIcon iconName={iconName} color={grey_80} size={iconSize} />
}

export default LoginLogoutIcon
